/**
 * Ressources Sonores – Zoogotos
 * Interactive Alphabet Cards with Sounds
 *
 * Dependencies: Swiper 11+ (loaded via CDN in section liquid)
 */
(function () {
    'use strict';

    var MAX_RETRIES = 50;
    var retries = 0;

    function initAllSections() {
        if (typeof Swiper === 'undefined') {
            if (++retries > MAX_RETRIES) {
                console.warn('[Ressources Sonores] Swiper.js not loaded after ' + MAX_RETRIES + ' retries.');
                return;
            }
            setTimeout(initAllSections, 100);
            return;
        }

        document.querySelectorAll('.rs-section').forEach(initSection);
    }

    /* ========================================
       Section Initialiser
       ======================================== */
    function initSection(section) {
        if (section.dataset.rsInitialized) return;
        section.dataset.rsInitialized = 'true';

        var initialSlide = 0;

        /* ---- Audio Engine ---- */
        var audio = new Audio();
        var currentPlayingBtn = null;

        function stopAudio() {
            audio.pause();
            audio.currentTime = 0;
            if (currentPlayingBtn) {
                currentPlayingBtn.classList.remove('playing');
                currentPlayingBtn = null;
            }
        }

        audio.addEventListener('ended', function () {
            if (currentPlayingBtn) {
                currentPlayingBtn.classList.remove('playing');
                currentPlayingBtn = null;
            }
        });

        /* ---- Thumbnail Swiper (initialise FIRST) ---- */
        var thumbEl = section.querySelector('.rs-thumb-slider');
        var friseSpacing = parseInt(section.dataset.friseSpacing, 10) || 16;
        var thumbSwiper = new Swiper(thumbEl, {
            slidesPerView: 7,
            spaceBetween: friseSpacing,
            loop: true,
            centeredSlides: true,
            slideToClickedSlide: true,
            watchSlidesProgress: true,
            initialSlide: initialSlide,
            breakpoints: {
                0: { slidesPerView: 3, spaceBetween: Math.max(2, Math.round(friseSpacing * 0.3)) },
                768: { slidesPerView: 5, spaceBetween: Math.max(6, Math.round(friseSpacing * 0.6)) }
            }
        });

        /* ---- Main Card Swiper ---- */
        var mainEl = section.querySelector('.rs-main-slider');
        var mainSwiper = new Swiper(mainEl, {
            slidesPerView: 1,
            spaceBetween: 0,
            effect: 'fade',
            fadeEffect: { crossFade: true },
            loop: true,
            allowTouchMove: false,
            initialSlide: initialSlide,
            navigation: {
                nextEl: section.querySelector('.rs-nav-next'),
                prevEl: section.querySelector('.rs-nav-prev')
            },
            thumbs: {
                swiper: thumbSwiper
            }
        });

        /* ---- Responsive Zoom (matches reference site) ---- */
        var BASE_WIDTH = 625; /* Reference vignette width at 1x */

        function updateZoom() {
            var vignette = section.querySelector('.rs-vignette');
            if (!vignette) return;
            var ratio = vignette.offsetWidth / BASE_WIDTH;
            /* Scale pictos, sound icons, and nav arrows */
            section.querySelectorAll('.rs-picto-animal, .rs-play-sound').forEach(function (el) {
                el.style.zoom = ratio;
            });
            section.querySelectorAll('.rs-nav-prev img, .rs-nav-next img').forEach(function (el) {
                el.style.zoom = ratio;
            });
        }

        /* Run on init and on window resize */
        updateZoom();
        window.addEventListener('resize', updateZoom);

        /* On slide change → reset flip + stop audio */
        mainSwiper.on('slideChange', function () {
            resetAllFlips(section);
            stopAudio();
            /* Sync thumb slider to keep active letter centered */
            thumbSwiper.slideToLoop(mainSwiper.realIndex, 300);
        });

        /* ---- Intro Card ---- */
        var intro = section.querySelector('.rs-intro');

        function dismissIntro() {
            if (!intro) return;
            intro.classList.add('hidden');
            section.classList.add('started');
        }

        if (intro) {
            intro.addEventListener('click', dismissIntro);
            /* Also dismiss on first thumb click */
            thumbEl.addEventListener('click', function onThumbClick() {
                dismissIntro();
                thumbEl.removeEventListener('click', onThumbClick);
            });
        } else {
            /* No intro → show arrows immediately */
            section.classList.add('started');
        }

        /* ---- Card Flip (click on picto animal) ---- */
        section.querySelectorAll('[data-flip]').forEach(function (picto) {
            picto.addEventListener('click', function (e) {
                e.stopPropagation();
                dismissIntro();
                var cardInner = picto.closest('.rs-card-inner');
                if (cardInner) {
                    cardInner.classList.toggle('flipped');
                }
            });
        });

        /* ---- Sound Playback ---- */
        section.querySelectorAll('.rs-play-sound').forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.stopPropagation();
                dismissIntro();

                var soundUrl = btn.dataset.sound;

                /* Toggle: if same button clicked while playing → stop */
                if (currentPlayingBtn === btn && !audio.paused) {
                    stopAudio();
                    return;
                }

                stopAudio();
                audio.src = soundUrl;
                audio.play().catch(function () {
                    /* Autoplay blocked or file missing – fail silently */
                });
                btn.classList.add('playing');
                currentPlayingBtn = btn;
            });
        });
    }

    /* ---- Helper: Reset all flipped cards ---- */
    function resetAllFlips(container) {
        container.querySelectorAll('.rs-card-inner.flipped').forEach(function (card) {
            card.classList.remove('flipped');
        });
    }

    /* ========================================
       Boot
       ======================================== */
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initAllSections);
    } else {
        initAllSections();
    }

    /* Shopify Theme Editor – live reload support */
    document.addEventListener('shopify:section:load', function (e) {
        var section = e.target.querySelector('.rs-section');
        if (section) {
            section.removeAttribute('data-rs-initialized');
            initSection(section);
        }
    });
})();
